
export const common = {
  // Navbar
  nav_home: 'Home',
  nav_services: 'Services',
  nav_process: 'Process',
  nav_references: 'References',
  nav_about: 'About',
  nav_contact: 'Contact',
  nav_cta: 'Request a Consultation',

  // Hero
  hero_title: 'Land & Development Consultancy in Sicily',
  hero_subtitle: 'Slope analysis, feasibility and due diligence to support informed land and development decisions.',
  hero_feature1: 'Technical Analysis',
  hero_feature2: 'Clear Documentation',
  hero_feature3: 'Local Context in Sicily',

  // Services
  services_title: 'Our Services',
  services_subtitle: 'Comprehensive land consultancy services tailored to support development projects across Sicily.',
  
  service1_title: 'Land Consultancy',
  service1_desc: 'Strategic guidance for land acquisition and development planning.',
  service1_point1: 'Site selection and evaluation',
  service1_point2: 'Development potential assessment',

  service2_title: 'Slope Analysis',
  service2_desc: 'Detailed topographical assessment to support construction planning.',
  service2_point1: 'Gradient mapping and classification',
  service2_point2: 'Stability and constraint identification',

  service3_title: 'Feasibility Analysis',
  service3_desc: 'Comprehensive evaluation of project viability and constraints.',
  service3_point1: 'Technical and regulatory review',
  service3_point2: 'Risk and opportunity assessment',

  service4_title: 'Due Diligence',
  service4_desc: 'Thorough assessment of land characteristics and compliance.',
  service4_point1: 'Title and zoning verification',
  service4_point2: 'Environmental and physical constraint review',

  service5_title: 'Permitting Support',
  service5_desc: 'Guidance through regulatory requirements and approval processes.',
  service5_point1: 'Documentation preparation assistance',
  service5_point2: 'Regulatory pathway clarification',

  service6_title: 'GIS / Mapping',
  service6_desc: 'Spatial data analysis and visualization to support informed decisions.',
  service6_point1: 'Custom mapping and layered analysis',
  service6_point2: 'Data integration and reporting',

  // Process
  process_title: 'Our Process',
  process_subtitle: 'A structured approach focused on clarity and decision support at every stage.',
  
  process1_title: 'Site Selection',
  process1_desc: 'Initial site review, location assessment, and high-level constraints identification.',
  
  process2_title: 'Technical Analysis',
  process2_desc: 'Detailed technical evaluation including slope analysis, feasibility review, and GIS-based assessment.',
  
  process3_title: 'Permitting Process',
  process3_desc: 'Regulatory review, permitting pathway clarification, and documentation support.',

  // Case Studies
  cases_title: 'Service Reference Overview',
  cases_subtitle: 'Typical analysis types and service scope.',
  
  case1_title: 'Land Screening for Development Potential',
  case1_desc: 'Technical evaluation of multiple parcels to identify sites suitable for residential development.',
  case1_scope: 'Topographical analysis, zoning review, access assessment, and preliminary constraint mapping.',
  case1_deliverables: 'Comparative site analysis with technical documentation of site characteristics and constraints.',

  case2_title: 'Slope Constraints Review for Site Planning',
  case2_desc: 'Assessment of terrain characteristics and limitations for proposed development sites.',
  case2_scope: 'Detailed slope gradient analysis, cut-and-fill estimation, and buildable area identification.',
  case2_deliverables: 'Technical documentation of terrain characteristics, grading considerations, and infrastructure requirements.',

  case3_title: 'Due Diligence for Land Acquisition',
  case3_desc: 'Comprehensive review of land characteristics and regulatory compliance for acquisition evaluation.',
  case3_scope: 'Title verification, regulatory compliance check, environmental screening, and physical site assessment.',
  case3_deliverables: 'Technical report documenting site characteristics, regulatory status, and identified constraints.',

  case_scope_label: 'Typical Scope:',
  case_deliverables_label: 'Deliverables:',

  // About
  about_title: 'About Service Immobil Sicily',
  about_p1: 'Service Immobil Sicily provides land consultancy services focused on technical analysis and decision support for development projects across Sicily.',
  about_p2: 'Our approach is grounded in data-driven evaluation, combining GIS technology, field assessment, and regulatory knowledge to deliver clear, actionable insights.',
  about_p3: 'We emphasize transparent reporting and practical recommendations, helping clients understand site characteristics, constraints, and opportunities to make informed land and development decisions.',
  about_feature1: 'Data-Driven Approach',
  about_feature2: 'Transparent Reporting',
  about_feature3: 'Practical Recommendations',

  // Contact
  contact_title: 'Get in Touch',
  contact_subtitle: 'Ready to discuss your land development project? Contact us to request a consultation.',
  contact_heading: "Let's Discuss Your Project",
  contact_intro: "Whether you're evaluating a site, planning a development, or need technical analysis, we're here to help. Reach out to discuss your requirements and the best next steps.",
  contact_email_label: 'Email',
  
  form_fullname: 'Full Name',
  form_company: 'Company',
  form_email: 'Email',
  form_phone: 'Phone',
  form_service: 'Service of Interest',
  form_location: 'Location / Area',
  form_details: 'Project Details',
  form_select_service: 'Select a service',
  form_submit: 'Send Message',
  form_submitting: 'Sending...',
  form_success: "Thank you! Your message has been sent successfully. We'll get back to you soon.",
  form_error: "Sorry, there was an error sending your message. Please try again or contact us directly.",
  form_consent: 'By submitting this form, you consent to the collection and processing of your information for the purpose of responding to your inquiry.',
  form_required: '*',
  form_chars: 'characters',
  
  placeholder_fullname: 'Your full name',
  placeholder_company: 'Your company name',
  placeholder_email: 'your.email@example.com',
  placeholder_phone: '+39 123 456 7890',
  placeholder_location: 'Project location in Sicily',
  placeholder_details: 'Brief description of your project and requirements',

  // Footer
  footer_desc: 'Professional land consultancy services in Sicily, providing technical analysis and decision support for development projects.',
  footer_services: 'Services',
  footer_company: 'Company',
  footer_contact: 'Contact',
  footer_about: 'About Us',
  footer_copyright: 'All rights reserved.'
};

export default common;
